import React from 'react';
import queryString from 'query-string';

import DishCardUpsell from 'app/components/DishCardUpsell';
import Responsive from 'app/components/Responsive';

import { DishCardUpsellDesktop } from '../../Dish/DishCardUpsell';

import imgMobile from './menu-link-mobile.jpg';
import imgDesktop from './menu-link-desktop.jpg';


export function DishCategorySecondaryLinkToMenu() {
    const { search } = window.location;
    const params = queryString.parse(search);
    const linkSearch = queryString.stringify({
        ...params,
        payment: 'online',
    });
    const href = `/menu/?${linkSearch}`;

    const titleMobile = {
        strong: 'Соберите своё меню',
        regular: 'Каждую неделю 50 новых блюд',
    };

    const titleDesktop = {
        strong: 'Соберите своё меню',
        regular: [
            'Каждую неделю 50 новых блюд',
            'на любой вкус',
        ],
    };

    return (
        <a href={href}>
            <Responsive
                mobile={(
                    <DishCardUpsell
                        id="link-to-menu"
                        locale="ru"
                        previewMobileImage={imgMobile}
                        strongTitle={titleMobile.strong}
                        title={titleMobile.regular}
                        titleEn=""
                        loading={false}
                        dishPrice={1}
                    />
                )}
                desktop={(
                    <DishCardUpsellDesktop
                        imageUrl={imgMobile}
                        imageUrlDesktop={imgDesktop}
                        strongTitle={titleDesktop.strong}
                        title={titleDesktop.regular}
                    />
                )}
            />
        </a>
    )
}
